import React from 'react'

import {
    Dialog,
    DialogContent,
    Typography,
    Box,
    useTheme,
    IconButton,
    Container,
} from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'

import { InternalInvoice } from '../../models/Invoice/types'

interface Props {
    invoice: InternalInvoice | null
    onClose: () => void
}

export const ViewInvoice: React.FC<Props> = ({ invoice, onClose }) => {
    const open = !!invoice
    const theme = useTheme()
    if (!invoice) return null

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xl"
            fullWidth
            PaperProps={{
                style: {
                    height: '80vh',
                    maxHeight: '80vh',
                    width: '80vw',
                    maxWidth: '80vw',
                },
            }}
        >
            <Container
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                }}
            >
                <Container
                    style={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography variant="h6">View Invoice</Typography>
                </Container>
                <Container
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        minWidth: 120,
                    }}
                >
                    <IconButton onClick={onClose}>
                        <CloseIcon fontSize="large" />
                    </IconButton>
                </Container>
            </Container>
            <DialogContent>
                {invoice.invoice ? (
                    <Box height="100%" display="flex" flexDirection="column">
                        <Box flex={1} style={{ minHeight: 0 }}>
                            <iframe
                                src={invoice.invoice}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    border: 'none',
                                    backgroundColor:
                                        theme.palette.background.paper,
                                }}
                                title="Invoice PDF"
                            />
                        </Box>
                    </Box>
                ) : (
                    <Box
                        height="100%"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bgcolor={theme.palette.background.paper}
                        borderRadius={theme.shape.borderRadius}
                    >
                        <Typography color="textSecondary">
                            No PDF available for this invoice
                        </Typography>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    )
}
